'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tooltip = require('./Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _lodash = require('lodash.capitalize');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfilePop = function (_Component) {
  _inherits(ProfilePop, _Component);

  function ProfilePop() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProfilePop);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProfilePop.__proto__ || Object.getPrototypeOf(ProfilePop)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false,
      viewportWidth: 0
    }, _this.updateDimensions = function () {
      _this.setState({ viewportWidth: window.innerWidth });
    }, _this.handleClose = function () {
      _this.state.open && _this.setState({ open: false });
    }, _this.toggle = function () {
      _this.setState({ open: !_this.state.open });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProfilePop, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateDimensions);
      this.updateDimensions();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isLoggedIn = _props.isLoggedIn,
          profile = _props.profile,
          onSettingsClicked = _props.onSettingsClicked,
          onLogInClicked = _props.onLogInClicked,
          onLogOutClicked = _props.onLogOutClicked;

      var _ref2 = profile || this.props,
          email = _ref2.email,
          name = _ref2.name,
          picture = _ref2.picture,
          domain = _ref2.domain;

      if (!domain) {
        domain = email ? (0, _lodash2.default)(email.replace(/.*@/, '').split('.')[0]) : '';
      }

      if (!picture) {
        picture = 'https://i2.wp.com/cdn.auth0.com/avatars/' + name[0] + '.png?ssl=1';
      }

      if (!isLoggedIn) {
        return _react2.default.createElement(
          'button',
          { onClick: onLogInClicked, className: 'btn btn-outline-secondary btn-sm' },
          'Log In'
        );
      }

      var profileContents = _react2.default.createElement(
        'div',
        { className: 'text-center' },
        _react2.default.createElement(
          'div',
          { className: 'popover-content' },
          _react2.default.createElement('img', { className: 'avatar', src: picture }),
          _react2.default.createElement(
            'div',
            { className: 'username' },
            name
          ),
          _react2.default.createElement(
            'div',
            { className: 'email' },
            email
          )
        ),
        onSettingsClicked ? _react2.default.createElement(
          'div',
          { className: 'popover-content' },
          _react2.default.createElement(
            'a',
            { className: 'clickable', style: { justifyContent: 'center' }, onClick: onSettingsClicked },
            _react2.default.createElement('i', { className: 'fa fa-cogs' }),
            '\xA0Settings'
          )
        ) : null,
        _react2.default.createElement(
          'div',
          { className: 'popover-content' },
          _react2.default.createElement(
            'button',
            { onClick: onLogOutClicked, className: 'btn btn-secondary btn-block' },
            'Log Out'
          )
        )
      );
      return _react2.default.createElement(
        'div',
        { className: 'mcp-navbar-userbox' },
        _react2.default.createElement(
          _Tooltip2.default,
          {
            variety: 'popover',
            className: 'user-popover',
            show: this.state.open,
            onClickOutside: this.handleClose,
            direction: 'bottom',
            contents: profileContents },
          _react2.default.createElement(
            'a',
            { className: 'clickable', onClick: this.toggle },
            this.state.viewportWidth > 500 ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'username' },
                name
              ),
              _react2.default.createElement(
                'div',
                { className: 'organization' },
                domain
              )
            ) : null,
            _react2.default.createElement('img', { className: 'avatar', src: picture })
          )
        )
      );
    }
  }]);

  return ProfilePop;
}(_react.Component);

exports.default = ProfilePop;


ProfilePop.propTypes = {
  profile: _propTypes2.default.object,
  name: _propTypes2.default.string,
  domain: _propTypes2.default.string,
  email: _propTypes2.default.string,
  onSettingsClicked: _propTypes2.default.func,
  onLogOutClicked: _propTypes2.default.func.isRequired,
  onLogInClicked: _propTypes2.default.func.isRequired,
  isLoggedIn: _propTypes2.default.bool
};

ProfilePop.defaultProps = {
  name: 'Unknown',
  email: 'Unknown@email.com'
};